import { scoreTier } from '@/lib/theme';

interface Props {
  score: number;
}

export function ScoreRing({ score }: Props) {
  const radius = 58;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(score, 100) / 100) * circumference;
  const { label, color } = scoreTier(score);

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-36 h-36 rounded-full">
        <div className="absolute inset-2 rounded-full border border-[var(--mx-border-subtle)] bg-[var(--mx-bg-elevated)]" />
        <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 128 128">
          <circle
            cx="64" cy="64" r={radius}
            fill="none"
            stroke="rgba(255,255,255,0.06)"
            strokeWidth="5"
          />
          <circle
            cx="64" cy="64" r={radius}
            fill="none"
            stroke={color}
            strokeWidth="5"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 0.7s cubic-bezier(0.4,0,0.2,1), stroke 0.5s ease' }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-4xl font-semibold tabular-nums leading-none tracking-tight text-[var(--mx-text)]">
            {score}
          </span>
          <span className="mx-label mt-1.5">分</span>
        </div>
      </div>

      <div className="mt-4 flex flex-col items-center gap-1.5">
        <span className="mx-label">姿态评分</span>
        <span
          className="text-xs font-medium px-2.5 py-0.5 rounded-full border border-[var(--mx-border-subtle)] bg-[var(--mx-bg-elevated)]"
          style={{ color }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}
